"use strict";

exports.__esModule = true;
exports.whenModern = void 0;
/**
 * A styled-components interpolation that emits `modernStyles` under the
 * modern UI and `legacyStyles` (default: nothing) otherwise. Both may be
 * `css` fragments or plain strings. Lets one styled component carry both
 * looks without a second file:
 *
 *   ${whenModern(css`border-radius: 8px;`, css`border: 1px solid grey;`)}
 */
var whenModern = exports.whenModern = function whenModern(modernStyles, legacyStyles) {
  if (legacyStyles === void 0) {
    legacyStyles = null;
  }
  return function (_ref) {
    var theme = _ref.theme;
    return theme && theme.uiModern ? modernStyles : legacyStyles;
  };
};